// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#covid-questions-list li {\n\t\tdisplay: flex;\n\t\twidth: 45em;\n\t}\n\t#covid-questions-list a {\n\t\tflex: auto 1 1;\n\t}\n.covid-question-stat {\n\tflex: 5em 0 0;\n}\n.covid-question-stat .covid-question-bar {\n\t\tbackground-color: rgba(60, 153, 220, 0.8);\n\t\tcolor: #eee;\n\t\tpadding: 0.25em;\n\t}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
